import { render, staticRenderFns } from "./concactUs.vue?vue&type=template&id=16632a74&scoped=true"
import script from "./concactUs.vue?vue&type=script&lang=js"
export * from "./concactUs.vue?vue&type=script&lang=js"
import style0 from "./concactUs.vue?vue&type=style&index=0&id=16632a74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16632a74",
  null
  
)

export default component.exports